import { render, staticRenderFns } from "./modalCreate.vue?vue&type=template&id=3fbf9598"
import script from "./modalCreate.vue?vue&type=script&lang=js"
export * from "./modalCreate.vue?vue&type=script&lang=js"
import style0 from "./modalCreate.vue?vue&type=style&index=0&id=3fbf9598&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports